// extracted by mini-css-extract-plugin
export default {"wrapper":"TemporaryDeactivatedView_wrapper__7Ms3M","header":"TemporaryDeactivatedView_header__hvT+b"};